import { Component, Input, OnInit } from '@angular/core';
import { CategoryService } from '../../../../service/category.service';
import { TranslateModule } from '@ngx-translate/core';
import { ChannelService } from '../../../../service/channel.service';
import { TreeSelectModule } from 'primeng/treeselect';
import { ButtonModule } from 'primeng/button';
import { FormsModule } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { CommonModule } from '@angular/common';
import { SelectModule } from 'primeng/select';
import { MessageService, ScrollerOptions } from 'primeng/api';
import { TableLazyLoadEvent, TableModule } from 'primeng/table';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { ToastModule } from 'primeng/toast';
import { Shop } from '../../../../../shop/types/shop.type';
import { ShopService } from '../../../../../shop/service/shop.service';
import { PaginatorModule } from 'primeng/paginator';

@Component({
  selector: 'app-mapping-widget-attribute',
  standalone: true,
  imports: [
    FormsModule,
    CommonModule,
    TranslateModule,
    TreeSelectModule,
    ButtonModule,
    DialogModule,
    SelectModule,
    TableModule,
    IconFieldModule,
    InputIconModule,
    InputTextModule,
    ToastModule,
    PaginatorModule
  ],
  providers: [MessageService],
  templateUrl: './mapping-widget-attribute.component.html',
  styleUrl: './mapping-widget-attribute.component.scss',
})
export class MappingWidgetAttributeComponent implements OnInit{
  @Input() nodes;
  @Input() associated = false;
  @Input() type;
  @Input() importShopCode;

  attributes: any = [];
  showModal = false;
  showRuleModal = false;
  loading: boolean;
  selectedNode = null;
  defaultLocale;
  workingNode;
  selectedAttribute;
  loadLazyTimeout = null;
  options: ScrollerOptions = {
    delay: 300,
    itemSize: 38,
    showLoader: true,
    lazy: true,
    onLazyLoad: this.onLazyLoad.bind(this),
  };
  totalRecords: number;
  scroll: number;
  cols = [{ header: 'label', field: 'attributeLabel' }];
  data;
  searchKeyword = '';
  rows = 100;
  selectedCategory;
  categories;
  selectedLocale: string;
  locales: any = [];
  shopInfo: Shop;
  first: number = 0;
  rowsPaginator: number = 10;
  totalRecordsPaginator: number;
  displayedNodes: any[]; 
    
  constructor(
    private readonly categoryService: CategoryService,
    private readonly channelService: ChannelService,
    private readonly messageService: MessageService,
    private readonly shopService: ShopService,
  ) {}

  ngOnInit() {
    this.data = {
      attributeLabel: '',
      locale: [this.channelService.getSelectedLocale()],
      offset: 0,
      sortField: 'attributeCode',
      limit: this.rows,
    };

    if (this.type == 'identified') {
      for (const node of this.nodes) {
        node.associated = true;
      }
    }
    this.getShopChannel();
    this.totalRecordsPaginator = this.nodes.length
    this.updateDisplayedNodes();
  }

  onLazyLoad(event: TableLazyLoadEvent) {
    const currentPage = event.first / event.rows;
    this.data.offset = currentPage;
    this.data.limit = event.rows;
    this.data.attributeLabel = this.searchKeyword
    this.loading = true;
    this.categoryService.getAttributesPaginated(this.data).subscribe({
      next: (res) => {
        this.attributes = res['attributes'];
        this.totalRecords = res['totalCount'];
      }
    });
  }

  getShopChannel() {
    this.shopService.getShop(this.importShopCode).subscribe({
          next: (res) => {
            this.shopInfo = res as Shop;
            this.initLocales(this.shopInfo.shopChannel)
          },
        });
  }

  initLocales(channel) {
    this.locales = this.channelService.getLocalesForMapping(channel);
    this.selectedLocale = this.locales?.[0];
    for (const node of this.nodes) {
      node.selectedLocale = node.locale || this.selectedLocale;
    }
  }
  customAttributeSelection(node) {
    this.workingNode = node;
    this.showModal = true;
  }

  mapAttribute() {
    this.workingNode.mappedAttribute = structuredClone(this.selectedAttribute.attributeCode);
    this.workingNode.localized = structuredClone(this.selectedAttribute.localized);
    this.selectedAttribute = null;
    this.showModal = false;
  }

  assiciate(node) {
    if (node.mappedAttribute) {
      node.associated = true;
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'messages.error',
        detail: "mapping.you_must_map_an_attribute",
      });
    }
  }

  filterGlobal(event) {
    this.searchKeyword = event.target.value;
    this.onLazyLoad({ first: 0, rows: this.rows });
  }

  finishMapping() {
    return this.nodes.map((node) => {
      let mappedAttribute = node.mappedAttribute;
      return {
        vendorAttribute: node.vendorAttribute,
        mappedTypology: node.mappedTypology,
        mappedAttribute: mappedAttribute,
        locale: node.localized ? node.selectedLocale : node.locale
      };
    });
  }

  updateLocale(event, node) {
    this.selectedLocale = event;
    node.selectedLocale = event
    node.locale = event
  }

  onPageChange(event: any) {
    this.first = event.first;
    this.rowsPaginator = event.rows;
    this.updateDisplayedNodes();
  }

  updateDisplayedNodes() {
    this.displayedNodes = this.nodes.slice(this.first, this.first + this.rowsPaginator);
  }
}
